<template>
  <div class="app-main">
    <h4 class="land_title">完善账户信息</h4>
    <van-form ref="domform" @submit="onSubmit">
      <van-field v-model="form.name" label="姓名:" :rules="[{ required: true, message: '' }]" placeholder="请输入姓名" />

      <van-field v-model="fieldValue" is-link readonly type="textarea" label="所属机构" placeholder="请选择所属机构" @click="show = true" />

      <van-popup v-model="show" round position="bottom">
        <van-cascader v-model="cascaderValue" title="请选择所属机构" :options="options" @close="show = false" :field-names="fieldNames" @change="onChange" @finish="onFinish" />
      </van-popup>

      <div style="margin: 16px;">
        <van-button round block type="info" class="butland" native-type="submit">完成</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { improveAccountInformation, getDepartmentByParentCode } from '@/api/poster'
export default {
  name: 'PosterLand',
  data() {
    return {
      depart: '',
      form: {
        name: '',
        mechanism: '',
      },
      show: false,
      fieldValue: '',
      cascaderValue: '',
      fieldNames: {
        text: 'departName',
        value: 'departCode',
        children: 'children',
      },
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [],
    }
  },
  async created() {
    const res = await getDepartmentByParentCode({
      parentDepartCode: 'HMB'
    })
    res.forEach(element => {
      if (element.isParent) {
        element.children = []
      }
    });
    this.options = res
  },
  methods: {
    async onChange(value) {
      const res = await getDepartmentByParentCode({
        parentDepartCode: value.value
      })
      res.forEach(async (e) => {
        if (e.isParent) {
          e.children = []
        }
      })
      if (res.length == 0) {
        return
      }
      this.optionsFilter(this.options, value.value, res)
      // console.log('最新options', this.optionsFilter(this.options, value.value, res))
      // value.selectedOptions[value.tabIndex].children = res
    },
    optionsFilter(arr, val, res) {
      for (let i = 0; i < arr.length; i++) {
        if (val == arr[i].departCode) {
          arr[i].children = res
          return arr
        } else {
          if (arr[i].children && arr[i].children.length > 0) {
            this.optionsFilter(arr[i].children, val, res)
          }
        }
      }
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.departName).join('/');
    },
    onSubmit() {
      let dataArr = {
        id: this.$route.query.id,
        userName: this.form.name,
        agentDepartCode: this.cascaderValue,
        token: this.$route.query.token
      }
      improveAccountInformation(dataArr).then(res => {
        if (res.code === 1) {
          this.$router.push({
            path: '/poster-deal', query: {
              id: res.id,
              token: this.$route.query.token
            }
          })
        }
      })
    }

  }
}
</script>
<style lang='scss' scoped>
.app-main {
  padding: 0 px2rem(33);
}
.land_title {
  margin-top: px2rem(140);
  font-size: px2rem(46);
  font-weight: 500;
  color: #000;
  line-height: px2rem(69);
}
.dispflex {
  display: flex;
  > div:nth-child(1) {
    > ::after {
      content: '';
      width: 0px;
      height: 0px;
      border-top: 6px solid #000;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid transparent;
      position: absolute;
      top: 12px;
      right: 0;
    }
    width: 90px;
  }
  .van-cell::after {
    display: none;
  }
}
.sendverification {
  font-size: px2rem(34);
  color: #333;
  border: none;
}
.butland {
  height: px2rem(120);
  background: linear-gradient(to right, #ff6c61, #db0003);
  border-radius: px2rem(60);
  border-color: #edeef2;
}
/deep/.van-field--min-height .van-field__control {
  min-height: 90px;
}
</style>
